import { capitalize, isEmpty } from 'lodash-es';
import { FEATURES_CATEGORIES } from 'site-modules/shared/constants/inventory/features-and-specs';

export function getFeaturesByCategories(styleFeatures) {
  const featuresByCategories = {};

  FEATURES_CATEGORIES.forEach(({ titleCategory, featureCategory }) => {
    if (styleFeatures?.[titleCategory]?.length) {
      featuresByCategories[featureCategory] = styleFeatures?.[titleCategory];
    }
  });

  return featuresByCategories;
}

export const getSortedFeatures = featuresList => {
  if (!isEmpty(featuresList)) {
    return Object.keys(featuresList).reduce((featureDescriptions, key) => {
      const features = featuresList[key].reduce((acc, cur) => [...acc, capitalize(cur?.name)], []);
      return [...featureDescriptions, ...features];
    }, []);
  }
  return [];
};

export const getUpgradesOptions = ({ tmvOptionCodes, options, packages }) => {
  const selectedOptions = options?.filter(option => tmvOptionCodes.includes(option?.id));
  const selectedPackages = packages?.length
    ? packages
        .filter(pkg => pkg?.genericFeatures?.every(({ id }) => tmvOptionCodes.find(opt => opt === id)))
        .map(({ id, oemName }) => ({ id, name: oemName }))
    : [];

  return [...selectedPackages, ...selectedOptions];
};
